import {
    CUSTOMERS_SUCCESSFUL_FETCH,
    CUSTOMERS_SUCCESSFUL_SAVE,
    SHOW_ERROR_MESSAGE
} from 'reducers/constants';

import HttpClient from "utils/HttpClient/HttpClient"
import {AFILIATE_SUCCESSFUL_FETCH, AFILLIATE_SUCCESSFUL_FETCH} from "../constants";


export const fetchAffiliate = (searchCriteria, resolve, reject) => dispatch => {
    new HttpClient(true).get("oga/affiliate/search",
        { params: { searchCriteria: searchCriteria } })
        .then((response) => {
            console.log("affiliate response", response);
            dispatch({
                type: AFILLIATE_SUCCESSFUL_FETCH,
                payload: response.data
            });
            resolve();
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
            reject();
        });
}






// WEBPACK FOOTER //
// ./src/reducers/affiliate/affiliateActions.js